<template>
	<div class="container">
		<div class="common-header-wrap">
			<mt-header class="common-header" :title="$t('login.forgot_password_title')">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<div class="main-content">
			<div class="topList">
				<div class="list">
					<div class="item">
						<label class="title active">{{ $t('login.forgot_password') }}</label>
					</div>
				</div>
			</div>
			<div class="top-wrapper">
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="number" v-model="username" :placeholder="$t('placeholder.mobile')" :attr="{ oninput: 'if(value.length>11)value=value.slice(0,11)' }" /></div></flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="number" v-model="verifyCodeMobile" :placeholder="$t('placeholder.captcha')" :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" /><div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{sendStateTextMobile}}</div></div></flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" :placeholder="$t('member.profile.new_password')" maxlength="20" /></div></flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="confirmPassword" :placeholder="$t('member.profile.new_password_confirmation')" maxlength="20" /><label v-if="!confirmPassword" class="tips">{{ $t('register.password_note') }}</label></div></flex-line>
			</div>
			<div class="common-btn ds-button-large mt-10" @click="onSubmit">{{ $t('general.submit') }}</div>
		</div>
	</div>
</template>

<script>
import { forget } from '../../../api/memberForget'
import { getSmsCaptcha } from '../../../api/common'
import { mapMutations, mapActions, mapState } from 'vuex'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  name: 'HomeMemberForget',
  components: {
    flexLine
  },
  data () {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: this.$t('general.send')
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    onSubmit () {
      forget(this.username, this.verifyCodeMobile, this.password, this.confirmPassword).then(
        response => {
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Toast(error.message)
        }
      )
    },
    sendVerifyCodeMobile () {
      if (!this.canSendMobile) {
        return
      }
      getSmsCaptcha(3, this.username).then(res => {
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
		  let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
			  _this.canSendMobile = true
			  _this.sendStateTextMobile = this.$t('general.send')
            clearInterval(_this.timeIntervalMobile)
          }else{
			  _this.sendStateTextMobile = second + 's'
		  }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.ds-button-large{margin:0 $pageSpace}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		.main-content{background: #fff;padding:1rem 0;}

		.input-wrapper {
			display: flex;
			flex-direction: row;
			align-content: flex-start;
			align-items: center;
			background-color: #fff;
			height:2.2rem;
			padding-left:0.5rem;
			input {
				flex: 1;
				font-size:$subFontSize
			}
			.bottom-input {
				border-bottom-width: 0;
			}
		}
	}
	.top-wrapper {
		margin:0 $pageSpace;
	}
	.bottom-wrapper {
		margin-top: 0.5rem;
	}
	.tips {
		color: $descTextColor;
		font-size:$fontSize;
		white-space: nowrap;
		position: absolute;
		right: 0;
		top:50%;
		margin-top:-.3rem;
	}
	.field-line-right{position: relative}
	.send-btn{border:1px solid $primaryColor;color:$primaryColor;min-width: 2rem}
	.topList {
		height:2rem;
		padding:1rem $pageSpace;
		.list {
			height: 100%;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-content: center;
			align-items: stretch;
			background-color: #fff;
		}
		.item {
			padding:0 .5rem;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.title {
			text-align: center;
			font-size:$h2;
			color: $formInputColor;
		}
		.active {
			color: $primaryColor;
			font-size:1.1rem;
		}
		.normal {
			color: #404245;
		}

	}
        .find_the_password_help{margin: 0 .6rem;font-size:$subFontSize;padding-top: .5rem;color: $descTextColor }
</style>
